<section fxLayout="column" fxLayoutAlign="center center" class="page-container default-padding">
  <section>
    <h1 class="larger-font">
      Welcome to GTAP platform. Thank you for taking the time to
      complete to this assessment.
    </h1>
    <section fxLayoutAlign="space-between center">
      <a mat-raised-button routerLink="/assessments/{{ assessment.id }}/testing_in_progress" color="primary">
        Start Assessment
      </a>
      <a mat-stroked-button routerLink="/assessments" color="warn">
        Cancel
      </a>
    </section>
  </section>
</section>
